// Notice.js — ES6 класс для уведомлений
class Notice {

    constructor(text, type = 'info', options = {}) {
        if (!text?.trim()) return;  // Ранний выход

        const { duration = 3000, containerSelector = '.notices_container' } = options;

        // Создаём DOM элемент (поддержка множественных)
        const div = document.createElement('div');
        div.className = `notice ${type}`;  // CSS классы: .notice.default, .notice.error
        div.textContent = text;  // Безопасно от XSS
        div.style.zIndex = '101';
        div.style.opacity = '0';  // Для CSS transition

        // Контейнер
        const container = document.querySelector(containerSelector) || this.createContainer();
        container.style.display = 'block';
        container.appendChild(div);  // Добавляем, не перезаписываем

        // Анимация появления
        requestAnimationFrame(() => div.style.opacity = '1');

        // Таймаут удаления
        const timeout = setTimeout(() => this.removeElement(div, container), duration);

        // Публичный API
        this.close = () => {
            clearTimeout(timeout);
            this.removeElement(div, container);
        };
    }

    createContainer() {
        const container = document.createElement('div');
        container.className = 'notices_container';
        document.body.appendChild(container);
        return container;
    }

    removeElement(div, container) {
        div.style.opacity = '0';
        div.addEventListener('transitionend', () => {
            div.remove();
            if (container.children.length === 0) {
                container.style.display = 'none';
            }
        }, { once: true });
    }
}

// Экспорт для Vite/модулей + глобал
export default Notice;
window.Notice = Notice;